import { render, staticRenderFns } from "./SingleOtpInput.vue?vue&type=template&id=1695d8c3&"
import script from "./SingleOtpInput.vue?vue&type=script&lang=js&"
export * from "./SingleOtpInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports